import React from "react";
import Skills from "./Skills.js";
import Tilt from "react-parallax-tilt";
import Lottie from "lottie-react";
import Coder from "../LottieFiles/coder.json";

const About = () => {
  const skillCategories = [
    {
      title: "Languages",
      skills: [
        "Python",
        "C++",
        "Java",
        "JavaScript",
        "TypeScript",
        "Go",
        "SQL",
        "HTML",
        "CSS",
      ],
    },
    {
      title: "Frameworks / Platforms",
      skills: [
        "React",
        "Next.js",
        "Node.js",
        "Express",
        "FastAPI",
        "Flask",
        "Angular",
        "Tailwind CSS",
      ],
    },
    {
      title: "Data & ML",
      skills: ["TensorFlow", "Keras", "scikit-learn", "pandas", "NumPy"],
    },
    {
      title: "Databases",
      skills: ["PostgreSQL", "MongoDB", "MySQL", "SQLite"],
    },
    {
      title: "Tools & Cloud",
      skills: [
        "AWS",
        "Docker",
        "Git",
        "GitHub",
        "GitHub Actions",
        "Redis",
        "Firebase",
        "Figma",
        "WebAssembly",
        "Postman",
        "Vercel",
      ],
    },
  ];

  return (
    <>
      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            Get to <b>know</b> me!
          </h1>
          <p>
            Hi, I’m <b>Vishnu Vardhana Reddy Devi Reddy</b>, a Computer Science
            undergraduate at
            <b> Arizona State University</b> (Class of 2027).
            <br />
            <br />
            I enjoy working on problems where software and data come together to
            solve something. I’m especially drawn to works that
            require thinking through real constraints, making trade-offs, and
            iterating based on feedback rather than just getting code to run.
            <br />
            <br />I like collaborating with others, breaking down ambiguous
            requirements, and turning ideas into systems that people can
            actually use. 
          </p>
        </div>

        <div>
          <Tilt>
            <Lottie
              className="illustration"
              animationData={Coder}
              loop={true}
            />
          </Tilt>
        </div>
      </div>

      <h1 className="SkillsHeading">Core Technologies</h1>
      <div className="skillsWrapper">
        {skillCategories.map((category) => (
          <div key={category.title} className="skillsCategory">
            <h3 className="SkillsSubheading">{category.title}</h3>
            <div className="skills">
              {category.skills.map((skill) => (
                <Skills key={skill} skill={skill} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default About;
